
import Loading from 'vux/src/components/loading/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Msg from 'vux/src/components/msg/index.vue'

import {mapState, mapGetters} from 'vuex'
export default {
data() {
return {
buttons: [
{
type: 'primary',
text: '重新加载',
onClick: this.Refesh
}
]
}
},
methods: {
Refesh: function () {
window.location.reload();
}
},
name: 'app',
components: {
Loading, Flexbox, FlexboxItem, Confirm, Msg
},
created() {


try {




} catch (e) {

}
},
computed: {
...mapGetters({
getUserInfo: 'GET_LOGININFO'
}),
...mapState({
isLoading: state => state.isLoading,
isAjaxfail: state => state.isAjaxfail
})
}
}



// WEBPACK FOOTER //
// ./src/App.vue